import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

const inFlightReadRequests = new Map();
const unreadCountTimers = new Map();

const scheduleUnreadCountUpdate = (commit, { id, lastSeen }) => {
  const existingTimer = unreadCountTimers.get(id);
  if (existingTimer) {
    clearTimeout(existingTimer);
  }

  const timer = setTimeout(() => {
    commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
    unreadCountTimers.delete(id);
  }, 4000);

  unreadCountTimers.set(id, timer);
};

export default {
  markMessagesRead: async ({ commit }, data) => {
    const { id: conversationId } = data;
    if (inFlightReadRequests.has(conversationId)) {
      return inFlightReadRequests.get(conversationId);
    }

    const request = ConversationApi.markMessageRead(data)
      .then(({ data: { id, agent_last_seen_at: lastSeen } }) => {
        scheduleUnreadCountUpdate(commit, { id, lastSeen });
      })
      .catch(() => {
        // Handle error
      })
      .finally(() => {
        inFlightReadRequests.delete(conversationId);
      });

    inFlightReadRequests.set(conversationId, request);
    return request;
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
